import React from "react";
import useGlobalHook from "use-global-hook";
import * as STATES from "./constants/states";

// localStorage.clear();

const initialState = {
    state: STATES.LOGGED_OUT,
    accountFilterId: null,
    appBarHeight: 72,
    appTitle: null,
    authUser: null,
    contactFilterId: null,
    dashboardWidgets: null,
    detailTabsTitle: null,
    dirty: false,
    editMode: false,
    editUser: null,
    firstName: null,
    lastName: null,
    lastPage: null,
    lastSaved: null,
    me: null,
    message: null,
    queryString: null,
    popupQueryObj: null,
    popupSaveText: null,
    showDetailTabLabels: false,
    showEditTabLabels: false,
    token: null,
};

const keys = [
    'accountFilterId',
    'appTitle',
    'authUser',
    'contactFilterId',
    'dashboardWidgets',
    'detailTabsTitle',
    'dirty',
    'editMode',
    'editUser',
    'firstName',
    'lastName',
    'lastPage',
    'lastSaved',
    'me',
    'message',
    'popupQueryObj',
    'popupSaveText',
    'showDetailTabLabels',
    'showEditTabLabels',
    'showTabLabels',
    'token',
];

let obj = {};

const loadErUp = () => {
    obj = {};

    const storedState = JSON.parse(localStorage.getItem('state'));
    obj.state = storedState;

    if (!storedState || storedState === STATES.LOGGED_OUT) {
        localStorage.setItem('state', JSON.stringify(STATES.LOGGED_OUT));
        obj.state = STATES.LOGGED_OUT;
        for (let k = 0; k < keys.length; k++) {
            const key = keys[k];
            obj[key] = null;
        }
    } else {
        for (let k = 0; k < keys.length; k++) {
            const key = keys[k];
            const str = localStorage.getItem(key);
            // if (key === 'dashboardWidgets') {
            //     obj[key] = null;
            // } else if (str && str !== 'undefined') {
            if (str && str !== 'undefined') {
                obj[key] = JSON.parse(str);
            } else {
                obj[key] = null;
            }
        }
    }
    obj.biggies = ['account', 'activity', 'contact', 'project', 'task'];
};

const actions = {
    setAccountFilterId: (store, value) => {
        store.setState({accountFilterId: value});
        localStorage.setItem('accountFilterId', JSON.stringify(value));
    },
    setAppTitle: (store, value) => {
        store.setState({appTitle: value});
        localStorage.setItem('appTitle', JSON.stringify(value));
    },
    setAuthUser: (store, value) => {
        store.setState({authUser: value});
        localStorage.setItem('authUser', JSON.stringify(value));
    },
    setContactFilterId: (store, value) => {
        store.setState({contactFilterId: value});
        localStorage.setItem('contactFilterId', JSON.stringify(value));
    },
    setDashboardWidgets: (store, value) => {
        store.setState({dashboardWidgets: value});
        localStorage.setItem('dashboardWidgets', JSON.stringify(value));
    },
    setDetailTabsTitle: (store, value) => {
        console.log('setting detailTabsTitle', value);
        store.setState({detailTabsTitle: value});
        localStorage.setItem('detailTabsTitle', JSON.stringify(value));
    },
    setDirty: (store, value) => {
        store.setState({dirty: value});
        localStorage.setItem('dirty', JSON.stringify(value));
    },
    setEditMode: (store, value) => {
        store.setState({editMode: value});
        localStorage.setItem('editMode', JSON.stringify(value));
    },
    setEditUser: (store, value) => {
        store.setState({editUser: value});
        localStorage.setItem('editUser', JSON.stringify(value));
    },
    setFirstName: (store, value) => {
        store.setState({firstName: value});
        localStorage.setItem('firstName', JSON.stringify(value));
    },
    setLastName: (store, value) => {
        store.setState({lastName: value});
        localStorage.setItem('lastName', JSON.stringify(value));
    },
    setLastPage: (store, value) => {
        store.setState({lastPage: value});
        localStorage.setItem('lastPage', JSON.stringify(value));
    },
    setLastSaved: (store, value) => {
        store.setState({lastSaved: value});
        localStorage.setItem('lastSaved', JSON.stringify(value));
    },
    setMessage: (store, value) => {
        store.setState({message: value});
        localStorage.setItem('message', JSON.stringify(value));
    },
    setPopupQueryObj: (store, value) => {
        store.setState({popupQueryObj: value});
        localStorage.setItem('popupQueryObj', JSON.stringify(value));
    },
    setPopupSaveText: (store, value) => {
        store.setState({popupSaveText: value});
        localStorage.setItem('popupSaveText', JSON.stringify(value));
    },
    clearPopupQueryObjSelectionText: (store) => {
         if (store.state.popupQueryObj) {
            actions.setPopupQueryObj(store, {
                ...store.state.popupQueryObj,
                selectionText: null
            });
        }
    },
    setShowDetailTabLabels: (store, value) => {
        store.setState({showDetailTabLabels: value});
        localStorage.setItem('showDetailTabLabels', JSON.stringify(value));
    },
    setShowEditTabLabels: (store, value) => {
        store.setState({showEditTabLabels: value});
        localStorage.setItem('showEditTabLabels', JSON.stringify(value));
    },
    setShowTabLabels: (store, value) => {
        store.setState({showTabLabels: value});
        localStorage.setItem('showTabLabels', JSON.stringify(value));
    },
    setState: (store, value) => {
        store.setState({state: value});
        localStorage.setItem('state', JSON.stringify(value));
    },
    setToken: (store, value) => {
        store.setState({token: value});
        localStorage.setItem('token', JSON.stringify(value));
    },
    setMe: (store, value) => {
        store.setState({me: value});
        localStorage.setItem('me', JSON.stringify(value));
    },
    clearBiggie: (store, biggie) => {
        if (biggie === 'account') actions.setAccount(store);
        if (biggie === 'activity') actions.setActivity(store);
        if (biggie === 'contact') actions.setContact(store);
        if (biggie === 'project') actions.setProject(store);
        if (biggie === 'task') actions.setTask(store);
    },
    clearAllBiggies: (store) => {
        actions.setAccount(store);
        actions.setActivity(store);
        actions.setContact(store);
        actions.setProject(store);
        actions.setTask(store);
    },
    clearStorage: (store) => {
        const newState = {...initialState, popupQueryObj: store.popupQueryObj};
        store.setState(newState);
        loadErUp();
    },
    closePopup: (store) => {
        // if (store.popupQueryObj && store.popupQueryObj.selectionUrl) {
        if (store.popupQueryObj) {
            // window.parent.postMessage({action: 'close-window'}, store.popupQueryObj.selectionUrl);
            store.setPopupQueryObj();
        }
    }
};

loadErUp();

const usePersistentStore = useGlobalHook(React, obj, actions);

export default usePersistentStore;
